import React from 'react';
import { Modal, Button, Row, Col, ListGroup, Alert, Spinner } from 'react-bootstrap';

const TableTransferModal = ({
  show,
  handleClose,
  sourceTable,
  tables,
  floors,
  onTransfer,
  destinationStates = {},
  isSubmitting = false,
  errorMessage = '',
}) => {
    if (!sourceTable) {
        return null;
    }

    const excludedTables = (tables || []).filter((table) => table.id !== sourceTable.id);

    const groupedTables = (floors || []).map(floor => ({
        ...floor,
        tables: excludedTables.filter(table => table.floor_id === floor.id)
    }));

    return (
        <Modal show={show} onHide={isSubmitting ? undefined : handleClose} dialogClassName="venue-transfer-modal">
            <Modal.Header closeButton={!isSubmitting}>
                <Modal.Title>Taşımak istediğiniz masayı seçiniz</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage ? <Alert variant="danger">{errorMessage}</Alert> : null}
                <Row>
                    <Col style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {groupedTables.map(floor => (
                            <div key={floor.id} className="mb-3">
                                <h6>{floor.name}</h6>
                                <ListGroup>
                                    {floor.tables.map(table => {
                                        const state = destinationStates[table.id] || { disabled: false, label: '' };
                                        const disabled = Boolean(state.disabled || isSubmitting);

                                        return (
                                            <ListGroup.Item
                                                key={table.id}
                                                action={!disabled}
                                                disabled={disabled}
                                                onClick={() => {
                                                    if (!disabled) {
                                                        onTransfer(table.id);
                                                    }
                                                }}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <span>{table.name}</span>
                                                {state.label ? (
                                                    <span className="text-danger small fw-semibold">{state.label}</span>
                                                ) : null}
                                            </ListGroup.Item>
                                        );
                                    })}
                                </ListGroup>
                            </div>
                        ))}
                    </Col>
                </Row>
                {isSubmitting ? (
                    <div className="text-muted small mt-3 d-flex align-items-center gap-2">
                        <Spinner animation="border" size="sm" />
                        Masa taşıma işlemi yapılıyor...
                    </div>
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <div className="venue-modal-actions">
                    <Button variant="outline-secondary" onClick={handleClose} disabled={isSubmitting}>
                        Kapat
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default TableTransferModal;
